<template>
  <div class="card p-shadow-6">
    <h1>Extranet Estados & Workflow</h1>
    <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />
    <ConfirmDialog></ConfirmDialog>

    <template>
      <div class="picklist-scroll-wrapper">
        <PickList
          v-model="list"
          dataKey="id"
          class="p-mt-6 fixed-picklist"
        >
          <template #sourceheader>
            <div class="p-d-flex p-jc-between p-ai-center">
              <span>Estados</span>
              <Button
                v-if="can('createExtranetStatus')"
                icon="pi pi-plus"
                class="p-button-sm p-button-primary"
                @click="openUserDialog('estado', null)"
              />
            </div>
          </template>

          <template #targetheader>
            <div class="p-d-flex p-jc-between p-ai-center">
              <span>Workflow</span>
              <Button
                v-if="can('createExtranetStatus')"
                icon="pi pi-plus"
                class="p-button-sm p-button-primary"
                @click="openUserDialog('workflow', null)"
              />
            </div>
          </template>

          <template #item="slotProps">
            <div
              class="p-caritem p-d-flex p-ai-center p-jc-between"
              style="width:100%;"
            >
              <div class="p-d-flex p-ai-center" style="gap:.5rem">
                <div>
                  <span class="p-caritem-vin">{{ slotProps.item.name }}</span>
                </div>
              </div>

              <div class="p-d-flex" style="gap:.5rem">
                <Button
                  v-if="can('updateExtranetUser')"
                  icon="pi pi-pencil"
                  v-tooltip.left="'Editar'"
                  class="p-button-sm p-button-rounded p-button-success"
                  @click.stop="openUserDialog('', slotProps.item)"
                />
                <Button
                  v-if="can('updateExtranetUser')"
                  icon="pi pi-angle-down"
                  v-tooltip.left="'Estados'"
                  class="p-button-sm p-button-rounded p-button-secondary"
                  @click.stop="openEstados($event, slotProps.item)"
                />
              </div>
            </div>
          </template>
        </PickList>
      </div>

      <OverlayPanel
        ref="opEstados"
        appendTo="body"
        :showCloseIcon="true"
        style="width: 300px"
      >
        <div class="p-mb-2 p-text-bold">{{ currentItem?.name }}</div>
        <ul class="p-ml-2">
          <li v-for="item in currentItemData" :key="item.id">{{ item.name }}</li>
        </ul>
      </OverlayPanel>

      <div v-if="isChanged">
        <hr />
        <div class="p-mt-3 p-d-flex p-jc-center" style="gap:.5rem">
          <Button
            label="Cancelar"
            class="p-button-danger"
            @click="cancelOrderTypeChange"
          >
            <span class="p-mr-2">Cancelar</span>
            <i class="pi pi-times" />
          </Button>

          <Button
            label="Guardar Alterações"
            class="p-button-success"
            @click="updateTypeOrder"
          >
            <span class="p-mr-2">Guardar Alterações</span>
            <i class="pi pi-check" />
          </Button>
        </div>
      </div>
    </template>

    <Dialog
      :style="{ width: $isMobile() ? '100vw' : '40vw' }"
      :visible.sync="isFormOpen"
      :header="(form.id == undefined ? 'Novo' : 'Editar') + ' Estado'"
      :modal="true"
      :draggable="false"
      :closable="true"
    >
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12">
          <label for="name">Nome do Estado</label>
          <InputText
            id="name"
            name="name"
            v-validate="'required'"
            :class="{ 'p-invalid': errors.has('name') }"
            v-model="form.name"
          />
          <small v-if="errors.has('name')" class="p-error" role="alert">
            Nome do estado é obrigatório
          </small>
        </div>

        <div class="p-field p-col-12">
          <label for="intranetStatus">Estados</label>
          <MultiSelect
            id="intranetStatus"
            v-model="form.intranetStatus"
            :options="options"
            optionLabel="name"
            optionValue="id"
            display="chip"
            filter
            filterPlaceholder="Pesquisar estado"
            name="Estados"
            v-validate="'required'"
            :class="{ 'p-invalid': errors.has('Estados') }"
          appendTo="body"
          />
          <small v-if="errors.has('Estados')" class="p-error" role="alert">
            Tem de selecionar pelo menos 1
          </small>
        </div>

        <div class="p-field" :class="$isMobile() ? 'p-col-2' : 'p-col-1'">
          <label for="active">Activo</label>
        </div>
        <div class="p-field p-col-2">
          <InputSwitch id="active" v-model="form.active" />
        </div>
      </div>

      <template #footer>
        <Button
          :label="'Guardar'"
          icon="pi pi-check"
          class="p-button-success"
          :disabled="dialogLoading"
          :loading="dialogLoading"
          @click="saveStatus"
        />
        <Button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-danger"
          :disabled="dialogLoading"
          @click="closeUserDialog"
        />
      </template>
    </Dialog>
  </div>
</template>


<script>
import StatusService from "@/services/status.service";
import ExtranetStatusService from "@/services/extranetStatus.service";

export default {
  name: "ExtranetStatus",
  data () {
    return {
      loading: false,
      dialogLoading: false,
      isChanged: false,
      isFormOpen: false,

      originalList: [],
      list: [],
      status: [],
      workflow: [],

      currentItem: null,
      currentItemData: [],

      form: {},
      options: [],
    }
  },
  async created() {
    await this.loadStatus()
    await this.loadAllIntranetStatus();
  },
  methods: {
    async loadStatus() {
      await this.getStatus('estado')
      await this.getStatus('workflow')
      this.list = [this.status, this.workflow]
      this.originalList = [...this.list]
      this.isChanged = false
    },
    async loadAllIntranetStatus() {
      const intranetStatus = await StatusService.getAllPatStatus()
      this.options = intranetStatus
    },
    async getStatus(type) {
      this.loading = true
      const rawData = await ExtranetStatusService.getStatusByType(type)
      const status = rawData.map(item => ({
        id: item.id,
        name: item.name,
        type: item.type,
        active: item.active,
        intranetStatus: (item.to_dytable || []).map((rel) =>
          String(rel.intranet_status_id)
        ),
      }))
      if (type == 'estado') {
        this.status = status
      } else {
        this.workflow = status
      }
      this.loading = false
    },

    async createExtranetStatus(statusData) {
      this.dialogLoading = true
      statusData.active = statusData.active ? 1 : 0
      const response = await ExtranetStatusService.createStatus(statusData)
      if (!response) {
        this.dialogLoading = false
        return this.$toast.add({
          severity: 'error',
          summary: 'ERROR',
          detail: 'Falha ao criar Estado.',
          life: 3000,
        })
      }
      this.dialogLoading = false
      this.isFormOpen = false
      this.$toast.add({
        severity: 'success',
        summary: 'Estado criado com sucesso.',
        detail: "",
        life: 3000,
      })
      this.loadStatus()
    },
    async updateExtranetStatus(statusData) {
      this.dialogLoading = true
      statusData.active = statusData.active ? 1 : 0
      const response = await ExtranetStatusService.updateStatus(statusData.id, statusData)
      if (!response) {
        this.dialogLoading = false
        return this.$toast.add({
          severity: 'error',
          summary: 'ERROR',
          detail: 'Falha ao atualizar Estado.',
          life: 3000,
        })
      }
      this.dialogLoading = false
      this.isFormOpen = false
      this.$toast.add({
        severity: 'success',
        summary: 'Estado atualizado com sucesso.',
        detail: "",
        life: 3000,
      })
      this.loadStatus()
    },
    async updateTypeOrder() {
      this.loading = true
      const [status, workflow] = this.list || [[], []]
      const response = await ExtranetStatusService.updateTypeOrder(status, workflow)
      if (!response) {
        this.isChanged = false
        await this.loadStatus()
        this.loading = false
        this.$toast.add({
          severity: 'error',
          summary: 'ERROR',
          detail: 'Falha ao atualizar Estado.',
          life: 3000,
        })
        return
      }
      this.$toast.add({
        severity: 'success',
        summary: 'Alteração Guardada',
        detail: "",
        life: 3000,
      })
      await this.loadStatus()
      this.isChanged = false
      this.loading = false
    },
    async openUserDialog(type = null, status = null) {
      if (status) {
        this.form = {
          id: status.id,
          name: status.name,
          intranetStatus: Array.isArray(status.intranetStatus) ? [...status.intranetStatus] : [],
          type: status.type,
          active: status.active == 1
        }
      } else {
        this.form = {
          id: null,
          name: "",
          intranetStatus: [],
          type: type,
          active: true
        }
      }
      this.isFormOpen = true;
    },
    closeUserDialog() {
      this.isFormOpen = false;
    },
    saveStatus() {
      this.$validator.resume();
      this.$validator.validateAll().then((isValid) => {
        if (!isValid) return;

        this.$validator.pause();
        this.$validator.reset();

        const formData = JSON.parse(JSON.stringify(this.form))
        if (this.form.id == undefined) {
          this.createExtranetStatus(formData)
        } else {
          this.updateExtranetStatus(formData)
        }
      })
    },
    cancelOrderTypeChange() {
      this.list = [...this.originalList]
      this.isChanged = false
    },
    openEstados(evt, item) {
      this.currentItem = item;
      const ids = (item.intranetStatus || []).map(String);
      this.currentItemData = this.options.filter((o) =>
        ids.includes(String(o.id))
      );
      this.$refs.opEstados.toggle(evt);
    },
  },
  watch: {
    list: {
      deep: true,
      handler(newVal) {
        const cur = JSON.stringify(newVal || []);
        const orig = JSON.stringify(this.originalList || []);
        this.isChanged = cur !== orig;
      }
    }
  }
}
</script>

<style>
@media (max-width: 768px) {
  .picklist-scroll-wrapper {
    width: 100%;
    overflow-x: auto;
  }

  .fixed-picklist {
    min-width: 650px;
  }

  .fixed-picklist .p-picklist-source,
  .fixed-picklist .p-picklist-target {
    flex: 0 0 400px;
    max-width: 400px;
  }
}

</style>
